import BreadCrumb from '@/components/BreadCrumb.vue';
export default {
  components: {
    BreadCrumb
  }
};